import * as React from 'react';
import { useState } from 'react';
import type { IconType } from 'smoothie';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    HeroEmphasized,
    Icon,
    MinusIcon,
    PlusIcon,
    View,
    XStack,
    YStack,
} from 'smoothie';

interface RecurringTransferEndCountProps {
    onSubmit: (endCount?: number) => void;
    endCount?: number;
}

const RecurringTransferEndCount = ({
    onSubmit,
    endCount,
}: RecurringTransferEndCountProps) => {
    const [selectedEndCount, setSelectedEndCount] = useState(endCount ?? 2);

    return (
        <YStack width="100%" alignItems="center">
            <XStack gap={36} alignItems="center">
                <IncrementIcon
                    icon={MinusIcon}
                    disabled={selectedEndCount === 2}
                    onPress={() => {
                        if (selectedEndCount > 2)
                            setSelectedEndCount(selectedEndCount - 1);
                    }}
                />
                <HeroEmphasized width={75} textAlign="center">
                    {selectedEndCount}
                </HeroEmphasized>
                <IncrementIcon
                    icon={PlusIcon}
                    onPress={() => {
                        setSelectedEndCount(selectedEndCount + 1);
                    }}
                />
            </XStack>
            <BodyMediumRegular marginBottom={24}>Transfers</BodyMediumRegular>
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Save"
                onPress={() => {
                    onSubmit(selectedEndCount);
                }}
            />
        </YStack>
    );
};

interface IncrementIconProps {
    icon: IconType;
    onPress: () => void;
    disabled?: boolean;
}

const IncrementIcon = ({
    icon,
    onPress,
    disabled = false,
}: IncrementIconProps) => {
    return (
        <View
            backgroundColor={disabled ? '$gray300' : '$black'}
            borderRadius={100}
            padding={8}
            onPress={onPress}
            cursor={disabled ? 'default' : 'pointer'}
        >
            <Icon
                icon={icon}
                size={16}
                color={disabled ? '$gray1000' : '$white'}
            />
        </View>
    );
};

export default RecurringTransferEndCount;
